import { useMemo } from 'react';
import type { GetNpiListsMetadataRequest } from '../../lib/api/npiList';
import { useGetNPIListsMetadataQuery } from '../api/useNpiList';
import { useCurrentWorkspace } from '../useCurrentWorkspace';

interface NpiListsMetadataAPIOptions extends GetNpiListsMetadataRequest {
  refetchOnMount?: boolean;
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}

export const useNpiListsMetadataApi = (options: NpiListsMetadataAPIOptions) => {
  const { enabled = true, refetchOnMount = true, refetchOnWindowFocus = false, ...params } = options;
  const { accountID, advertiserID } = params;
  const hasRequiredParams = !!accountID && !!advertiserID;
  const { currentWorkspace } = useCurrentWorkspace();

  const {
    data,
    error: listMetadataError,
    isLoading: isListMetadataLoading,
    isFetching,
    isError: isListMetadataError,
    refetch: refetchListMetadata,
  } = useGetNPIListsMetadataQuery(params, {
    enabled: enabled && hasRequiredParams,
    refetchOnMount,
    refetchOnWindowFocus,
  });

  const excludedListName = currentWorkspace?.workspace_name;

  const filteredLists = useMemo(
    () => (data?.response.lists ?? []).filter((item) => item.listName !== excludedListName),
    [data?.response.lists, excludedListName],
  );

  return {
    listMetadata: filteredLists,
    listMetadataError,
    isListMetadataLoading: isListMetadataLoading || isFetching,
    isLoading: isListMetadataLoading,
    isFetching,
    isListMetadataError,
    refetchListMetadata,
  };
};
